<script setup lang="ts">
type Size = `${string}px`;

type Duration = `${string}ms`;

type Props = {
  show: boolean;
  size?: Size;
  duration?: Duration;
};

const { show, size = '40px', duration = '800ms' } = defineProps<Props>();

const isLoaderVisible = computed<boolean>(() => {
  return !!show;
});
</script>

<template>
  <div
    v-if="isLoaderVisible"
    :class="$style.iconLoader"
  >
    <div :class="$style.loaderContain">
      <div :class="$style.loaderIconEffect">
        <BaseCommonLogo
          always-icon
          :class="$style.icon"
          custom-size
        />
      </div>
      <BaseCommonLogo
        always-icon
        :class="$style.loaderIconFixed"
        custom-size
      />
    </div>
  </div>
</template>

<style module lang="scss">
.iconLoader {
  @apply flex m-auto p-0 w-full h-full;

  .loaderContain {
    @apply relative m-auto;
    width: auto;
    height: v-bind(size);

    .loaderIconEffect {
      @apply w-full h-full absolute top-0 left-0 overflow-hidden;
      animation-name: loaderEffect;
      animation-duration: v-bind(duration);
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      animation-direction: alternate;

      .icon {
        width: auto;
        height: v-bind(size);
      }
    }

    .loaderIconFixed {
      @apply opacity-30;
      width: auto;
      height: v-bind(size);
    }
  }
}

@keyframes loaderEffect {
  from {
    max-height: 100%;
  }
  to {
    max-height: 0%;
  }
}
</style>
